<!-- WiFi Connection Status Component - Always visible in main toolbar -->
<button
  style="margin: 0 3px; cursor: pointer"
  mat-mini-fab
  [color]="isConnected ? 'inherit' : 'warn'"
  [attr.aria-label]="tooltipKey | translate"
  class="d-flex justify-content-center"
  (click)="toggleConnectivityMode()"
  [matTooltip]="tooltipKey | translate"
>
  <i
    [style.color]="isConnected ? '#22B92D' : 'red'"
    class="iconify icon-22 d-flex"
    [attr.data-icon]="
      isConnected ? 'pepicons-pop:wifi' : 'pepicons-pop:wifi-off'
    "
  >
  </i>
</button>
